import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import dateFns from 'date-fns';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import LoadingDots from 'src/assets/loading_dots.svg';

import { ORG_SETUP_NEEDS_SYNC, ORG_SETUP_SYNC_ERROR } from 'src/utils/authOrg.constants';

import { fetchImportJobs } from 'src/redux/importJobs/importJob.action';
import {
	getImportJobs,
	getPendingImportJobs,
	getImportJobErrors,
} from 'src/redux/importJobs/importJob.selector';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import styles from '../index.css';
import {
	Heading,
	HyperLink,
	Paragraph,
	Box,
	FlexBox,
	UnorderedList,
	ListItem,
} from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class SyncError extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	retrySync = () => {
		this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
			setup_state: ORG_SETUP_NEEDS_SYNC,
		});
	};

	componentDidMount() {
		this.props.fetchImportJobs();
		if (!localStorage.syncRequestErrors && this.props.importJobErrors.create) {
			localStorage.syncRequestErrors = JSON.stringify(this.props.importJobErrors.create);
		}
		if (localStorage.syncRequestErrors) {
			this.setState({ syncRequestErrors: localStorage.syncRequestErrors });
		}
	}

	render() {
		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== ORG_SETUP_SYNC_ERROR) {
			return <Redirect to={{ pathname: '/' }} />;
		}

		// show loading dots if we're loading importjobs
		if (this.props.pendingImportJobs.fetch !== false) {
			return <LoadingDots className={styles.SetupLoadingDots} />;
		}

		const hasImportJobs = this.props.importJobs.length > 0;
		return (
			<FlexBox className={styles.SetupCardLayout}>
				<Heading {...theme.heading.setUpTitle}>Import Error</Heading>
				<Paragraph>Something went wrong with your sync!</Paragraph>
				<Paragraph mt="5px">
					{hasImportJobs ? 'Check your recent job history below and c' : 'C'}ontact us{' '}
					<HyperLink href="mailto:hello@fundraisewisely.com">via email</HyperLink> or via
					the intercom widget in the bottom right.
				</Paragraph>
				{hasImportJobs ? (
					<UnorderedList className={styles.SetupSyncError}>
						{/* we're only showing the most recent 10 jobs for now */}
						{this.props.importJobs.slice(0, 10).map(job => (
							<ListItem key={job._id}>
								{dateFns.format(job.start, 'HH:mm:ss.SSS Z')}: {job.task}:{' '}
								{job.status}, ran for {dateFns.distanceInWords(job.start, job.end)}
								{job.error ? `, error: ${job.error}` : ''}
							</ListItem>
						))}
					</UnorderedList>
				) : null}
				{this.state.syncRequestErrors ? (
					<Box>
						<Paragraph>
							{hasImportJobs ? 'Also, t' : 'T'}his error context was found from a
							recent request:
						</Paragraph>
						<Paragraph {...theme.paragraph.setupSyncError} pl="35px">
							{this.state.syncRequestErrors}
						</Paragraph>
					</Box>
				) : null}
				<Paragraph>If you'd like, you can retry your import by clicking here:</Paragraph>
				<RoundedRectangleButton
					className={styles.DefaultButton}
					fontSize="16px"
					onClick={this.retrySync}
				>
					Retry import
				</RoundedRectangleButton>
			</FlexBox>
		);
	}
}

const mapStateToProps = state => ({
	importJobs: getImportJobs(state),
	pendingImportJobs: getPendingImportJobs(state),
	importJobErrors: getImportJobErrors(state),
});

const actions = {
	fetchImportJobs,
	requestUpdateAuthOrganization,
};

SyncError = connect(mapStateToProps, actions)(SyncError);

export default SyncError;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/SyncError/index.js